import React from "react";
import { observer } from "mobx-react-lite";
import { Popup } from "../../../../ui-kit";
import DefectNotify from "../defectNotify/defectNotify";
import defectCardsStore from "../../../../store/defectCards";
import styles from "./defectNotifyPopup.module.scss";

const DefectNotifyPopup: React.FC = () => {
  const { defectsIds, filterDefectsIds, clearDefectsIds } = defectCardsStore;

  return (
    <Popup
      open={!!defectsIds.length}
      onClose={() => {
        clearDefectsIds();
      }}
      title={
        defectsIds.length > 1
          ? "Уведомление для дефектов:"
          : `Уведомление для дефекта № ${defectsIds[0]}`
      }
    >
      {defectsIds.map((id) => (
        <div key={id} className={styles.content}>
          {defectsIds.length > 1 && (
            <span className={styles.content__title}>{`дефект № ${id}`}</span>
          )}
          <DefectNotify defectId={id} onClose={() => filterDefectsIds(id)} />
        </div>
      ))}
    </Popup>
  );
};

export default observer(DefectNotifyPopup);
